// A trip without a plate can arrive as NULL; it reads N/A like an empty plate.
export const convertToDisplayLicensePlate = (licensePlate: string | null | undefined) => {
    return (licensePlate ?? '').split('_').pop() || 'N/A';
}

export const convertToDatabaseLicensePlate = (licensePlate: string) => {
    return 'ga_' + licensePlate;
}